import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 3h10v18h-10l0 -18","key":"svg-0"}]]

/**
 * IconBrandNationalGeographic
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtbmF0aW9uYWwtZ2VvZ3JhcGhpYyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNyAzaDEwdjE4aC0xMGwwIC0xOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/brand-national-geographic
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandNationalGeographic = createReactComponent('outline', 'brand-national-geographic', 'BrandNationalGeographic', __iconNode);

export default IconBrandNationalGeographic;